/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    NeedChangeHeader: {
        id: 'cep.components.SgWebchatInfo.NeedChangeHeader',
        defaultMessage: 'Need to make a change?'
    },
    NeedChangeMessage: {
        id: 'cep.components.SgWebchatInfo.NeedChangeMessage',
        defaultMessage: 'If you need to make an amendment to your renewal, please speak to our friendly customer service agents via'
    },
    NeedChangeMtaHeader: {
        id: 'cep.components.SgWebchatInfo.NeedChangeMtaHeader',
        defaultMessage: 'Need to make a change that isn\'t here?'
    },
    NeedChangeMtaMessage: {
        id: 'cep.components.SgWebchatInfo.NeedChangeMtaMessage',
        defaultMessage: 'If you need to change something else such as your address, you can get in touch with our friendly customer service agents using'
    },
    WebchatText: {
        id: 'cep.components.SgWebchatInfo.WebchatText',
        defaultMessage: 'webchat'
    },

});
